import React from 'react';
import styled from "styled-components";

export function ATContentWrapper({children,layout,is_mobile}) {

    return <div className={"relative flex-grow"} id="at-content-wrapper">
        {children}
    </div>
}